import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'

const CloseButton = ({ classes, onClick, dataElement, disabled, children }) => {
  return (
    <button
      onClick={onClick}
      type="button"
      data-element={dataElement}
      className={classes.button}
      disabled={disabled}
    >
      <Icon name="minus" />
      {children}
    </button>
  )
}

CloseButton.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  dataElement: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.string,
}

export default CloseButton
